/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, ElementRef} from '@angular/core';
import {CanDisable, mixinDisabled} from '../core/common-behaviors/disabled';
export class MdTabLabelWrapperBase {}
export const /** @type {?} */ _MdTabLabelWrapperMixinBase = mixinDisabled(MdTabLabelWrapperBase);
/**
 * Used in the `md-tab-group` view to display tab labels.
 * \@docs-private
 */
export class MdTabLabelWrapper extends _MdTabLabelWrapperMixinBase implements CanDisable {
/**
 * @param {?} elementRef
 */
constructor(public elementRef: ElementRef) {
    super();
  }
/**
 * Sets focus on the wrapper element
 * @return {?}
 */
focus(): void {
    this.elementRef.nativeElement.focus();
  }
/**
 * @return {?}
 */
getOffsetLeft(): number {
    return this.elementRef.nativeElement.offsetLeft;
  }
/**
 * @return {?}
 */
getOffsetWidth(): number {
    return this.elementRef.nativeElement.offsetWidth;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-tab-label-wrapper], [mat-tab-label-wrapper]',
  inputs: ['disabled'],
  host: {
    '[class.mat-tab-disabled]': 'disabled'
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
}

function MdTabLabelWrapper_tsickle_Closure_declarations() {
/** @type {?} */
MdTabLabelWrapper.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdTabLabelWrapper.ctorParameters;
/** @type {?} */
MdTabLabelWrapper.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
